var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoResp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.361,
    height: 37.875,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1122"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.545 37.875C8.585 37.875 0 29.586 0 19.007 0 8.349 8.585 0 19.545 0c10.921 0 19.476 8.349 19.476 19.007 0 10.58-8.555 18.868-19.476 18.868m0-30.641c-6.565 0-11.905 5.281-11.905 11.773 0 6.414 5.34 11.634 11.905 11.634 6.636 0 11.836-5.11 11.836-11.634 0-6.603-5.2-11.773-11.836-11.773",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.062 34.13H40.315a.777.777 0 0 1-.55-1.33c3.692-3.635 5.725-8.513 5.725-13.739 0-5.3-2.04-10.233-5.744-13.89a.759.759 0 0 1-.175-.846.777.777 0 0 1 .724-.482h19.767c8.436 0 15.299 6.793 15.299 15.144 0 8.35-6.863 15.143-15.3 15.143",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6467"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoResp);
export default __webpack_public_path__ + "static/media/logo-resp.40333063a97e7e340184ba10c70edf1d.svg";
export { ForwardRef as ReactComponent };